export default "__VITE_ASSET__CIMr6qFG__"